export function compareEvents(a, b) {
    const time = new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    if (time !== 0) {
        return time;
    }
    return a.id.localeCompare(b.id);
}
//# sourceMappingURL=compareEvents.js.map